/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Status_Generating_SstInputs */



/**
* | output |
* | --- |
* | "Generating SST script and FCP XML..." |
*
* @param {Image_Export_Status_Generating_SstInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_status_generating_sst = /** @type {((inputs?: Image_Export_Status_Generating_SstInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Status_Generating_SstInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generation du script SST et du XML FCP...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Generiere SST-Skript und FCP-XML...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generazione dello script SST e dell XML FCP in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Генерация скрипта SST и FCP XML...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generando el script SST y el XML FCP...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在生成 SST 脚本和 FCP XML...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SST スクリプトと FCP XML を生成しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("SST स्क्रिप्ट और FCP XML तैयार किए जा रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A gerar o script SST e o XML FCP...")
	return /** @type {LocalizedString} */ ("Generating SST script and FCP XML...")
});